export default "__VITE_ASSET__CvY8m4TD__"